/**
 * TextareaField Component
 *
 * textarea 타입 필드를 렌더링하는 컴포넌트
 * shadcn/ui Textarea 컴포넌트 사용
 */

import { Textarea } from '@/shared/ui/textarea';

import type { BaseFieldProps } from './types';

/**
 * 텍스트 영역 입력 필드
 */
export function TextareaField({ field, value, onChange, disabled, error }: BaseFieldProps) {
  return (
    <div className="flex flex-col gap-1">
      <Textarea
        id={field.id}
        name={field.name}
        placeholder={field.placeholder}
        disabled={disabled}
        autoComplete="off"
        className="min-h-[100px] rounded-md border-[#d9dde0] px-4 py-3 text-base"
        onChange={(e) => onChange(e.target.value)}
        value={(value as string) || ''}
        aria-invalid={!!error}
        rows={field.rows}
      />
      {error && <p className="text-sm text-red-500">{error}</p>}
    </div>
  );
}
